import {createSlice} from "@reduxjs/toolkit";
import {Severity} from "../state";
import {deleteInstrument, fetchInstruments} from "./instruments";
import {fetchTags, updateTags} from "./tags";

export const messageSlice = createSlice({
  name: "message",
  initialState: null,
  reducers: {
    setErrorMessage: (state: any, {payload}) => ({
      ...state, text: payload, severity: Severity.ERROR
    }),
    setSuccessMessage: (state: any, {payload}) => ({
      ...state, text: payload, severity: Severity.SUCCESS
    }),
    removeMessage: _ => null,
  },
  extraReducers: builder => {
    builder
    .addCase(fetchInstruments.rejected, (state: any) => {
      return ({
        ...state,
        text: "Die Instrumente konnten nicht geladen werden.",
        severity: Severity.ERROR
      })
    })
    .addCase(fetchTags.rejected, (state: any) => {
      return ({
        ...state,
        text: "Die Suchtags konnten nicht geladen werden.",
        severity: Severity.ERROR
      })
    })
    .addCase(deleteInstrument.rejected, (state: any) => {
      return ({
        ...state,
        text: "Das Instrument konnte nicht gelöscht werden.",
        severity: Severity.ERROR
      })
    })
    .addCase(updateTags.fulfilled, (state: any) => {
      return {
        ...state,
        text: "Die Änderungen wurden gespeichert.",
        severity: Severity.SUCCESS
      }
    })
    .addCase(updateTags.rejected, (state: any, action:any) => {
      return {
        ...state,
        text: action.payload != undefined ? action.payload.message : "Es ist ein Fehler aufgetreten",
        severity: Severity.ERROR
      }
    })
      },
    })
;

export const {setErrorMessage, setSuccessMessage, removeMessage} = messageSlice.actions;
export default messageSlice.reducer;